import React from 'react';
import './ConfirmInventoryModal.css';

export const ConfirmInventoryModal = ({isOpen, onClose, onConfirm, loading, title, message, confirmText, loadingText}) =>
{
  if (!isOpen) return null;

  const modalTitle = title || 'Confirm Inventory';
  const modalMessage = message || 'Are you sure you want to confirm this inventory? This action cannot be undone.';
  const btnText = confirmText || 'Yes, Confirm';
  const btnLoadingText = loadingText || 'Confirming...';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content confirm-inv-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{modalTitle}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <p className="confirm-inv-message">{modalMessage}</p>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="btn-confirm" onClick={onConfirm} disabled={loading}>
            {loading ? btnLoadingText : btnText}
          </button>
        </div>
      </div>
    </div>
  );
};
